module.exports = __webpack_public_path__ + "img/resort-03.cb3b8dcb.jpg";